"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _usePalette2 = _interopRequireDefault(require("../styles/PaletteProvider/usePalette"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2.default)(),
      colors = _useTheme.colors,
      fonts = _useTheme.fonts;

  var _usePalette = (0, _usePalette2.default)(),
      typography = _usePalette.typography;

  var link = typography.link;
  return {
    root: _objectSpread({}, fonts.primary, {
      color: colors[link],
      textDecoration: 'underline'
    })
  };
};

__signature__(useStyles, "useTheme{{ colors, fonts }}\nusePalette{{ typography }}", function () {
  return [_useTheme2.default, _usePalette2.default];
});

var Link = function Link(props) {
  var _props$as = props.as,
      Element = _props$as === void 0 ? 'span' : _props$as,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'link' : _props$variant,
      inactive = props.inactive,
      other = (0, _objectWithoutProperties2.default)(props, ["as", "variant", "inactive"]);
  var classes = useStyles();
  return (0, _core.jsx)(Element, (0, _extends2.default)({
    css: classes.root
  }, other));
};

__signature__(Link, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Link;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Text/Link.tsx");
  reactHotLoader.register(Link, "Link", "/builds/bA1zbJom/0/gojob/ui-bits/src/Text/Link.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Text/Link.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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